import React, { useContext, useEffect } from "react";
import nini from "../../assets/images/nini.jpg";
import mariam from "../../assets/images/mariam.png";
import defaultImg from "../../assets/images/defaultDp.png";
import Context from "../../services/Context";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const TutorCard = ({ dataItem, isSelected, onSelect }) => {
  const { value, updateValue } = useContext(Context);
  const param = useParams()

  console.log(dataItem?.name.split(".")[0] === 'Eidvile', "poooool")
  useEffect(() => {}, [dataItem]);

  const handleSelectTutor = () => {
    onSelect((prev) => ({
      ...prev,
      selectedTutor: dataItem,
    }))
    updateValue((prev) => ({...prev, dataItem: dataItem, selectedSlots: []}))
  }
  return (
    <div
  role="button"
  tabIndex={0}
  aria-label={`Select tutor: ${dataItem?.name.split(".")[0]}`}
  className={`flex lg:w-47% w-full border-0 p-2 gap-3 mb-3 bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 ${
    isSelected ? "border-4 border-borderGreen" : ""
  }`}
  style={{
    borderRadius: "25px",
    boxShadow: "rgba(2, 23, 54, 0.1) 4px 8px 20px",
  }}
  onClick={handleSelectTutor}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleSelectTutor();
    }
  }}
>
  <div className="flex flex-col justify-center items-center text-center mr-8">
    <div style={{ width: "150px", height: "150px", padding: "30px" }}>
      <img
        src={
          dataItem?.image
            ? dataItem.image.replace(
                "https://backend.simplestudying.com",
                "https://backend.studycrowd.ai"
              )
            : defaultImg
        }
        className="w-full h-full"
        style={{ borderRadius: "50%" }}
        alt={`Profile picture of ${dataItem?.name.split(".")[0]}`}
      />
    </div>
    <h3 className="fw-bold" style={{ fontSize: "22px" }}>
      {dataItem?.name.split(".")[0]}
    </h3>
    <p className="w-fit text-14">{dataItem?.designation}</p>
    <p className="w-36 text-14">{dataItem?.education}</p>
  </div>

  <div className="flex flex-col text-left margin-auto justify-center">
    {dataItem?.work_experience && (
      <div>
        <h5 className="text-primary text-body-large">Work Experience:</h5>
        <p>{dataItem.work_experience}</p>
      </div>
    )}
    {dataItem?.description && (
      <div>
        <h5 className="text-primary text-body-large">Description:</h5>
        <p>{param?.slug?.includes('advisor') && dataItem?.name.split(".")[0] === 'Eidvile' ? "Eidvile worked for two leading criminal defence firms as a paralegal and gained experience as a barrister's clerk in a leading human rights set. Currently, Eidvile works for a council and drafts Tribunal judgments. Aside from wide legal knowledge, Eidvile gained experience in applying for various legal internships and could assist students in seeking jobs and opportunities." : dataItem.description}</p>
      </div>
    )}
  </div>
</div>

  );
};

export default TutorCard;
